define("preview-grid/components/post", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <figure class={{concat-classes "o--mediaContainer cPV--mediaContainer"}}>
    {{#if this.textOnlyDraft}}
      <p class="cPV--mediaContainer__text">
        {{@post.description}}
      </p>
    {{else}}
      <img
        alt={{t "shared_words.draft"}}
        class={{concat-classes "o--media" (if @post.hasBeenEdited "is--selected")}}
        data-post-id={{@post.id}}
        src={{if @post.secureImageUrl @post.secureImageUrl "/assets/images/img--postThumbnail--placeholder--preview.png"}}
      />
    {{/if}}
    {{#unless this.hideActions}}
      <div class="cPV--media__darkOverlay"></div>
      {{#if @post.isDraftPost}}
        <span class="o--media__label--draft">
          {{svg-jar "draft-post" class="o--icon--lg o--icon--white"}}
        </span>
      {{/if}}
      {{#if (and @post.canMove @isFeedTab)}}
        <span class="o--media__label--status">
          {{svg-jar "move" class="o--icon o--icon--white"}}
        </span>
      {{/if}}
      {{#if @post.isIgPost}}
        <span class="o--media__label--status">
          <i class="i--ig--w"></i>
        </span>
      {{/if}}
      {{#if (and @post.canDelete @isFeedTab)}}
        <span class="o--media__label--select" {{on "click" (fn @removePreviewPost @post)}}>
          {{svg-jar "close" class="o--icon o--icon--white"}}
        </span>
      {{/if}}
      {{#if @post.isCarouselPost}}
        <span class="o--media__label--type">
          {{svg-jar "gallery" class="o--icon o--icon--white"}}
        </span>
      {{/if}}
      {{#if @post.isReelsPost}}
        <span class="o--media__label--type">
          {{svg-jar "ig-reels" class="o--icon o--icon--white"}}
        </span>
      {{/if}}
      {{#if @post.shouldShowVideoIcon}}
        <span class="o--media__label--type">
          {{svg-jar @post.mediaIcon class="o--icon o--icon--white"}}
        </span>
      {{/if}}
      {{#if @post.gram.autoPublish}}
        <span class="o--media__label--method">
          {{svg-jar "instant" class="o--icon o--icon--white"}}
        </span>
      {{else if @post.gram.isNotificationPost}}
        <span class="o--media__label--method">
          {{svg-jar "notification" class="o--icon o--icon--white"}}
        </span>
      {{/if}}
    {{/unless}}
  
    <b class="o--mediaOverlay"></b>
  </figure>
  */
  {
    "id": "zX26Amjq",
    "block": "[[[10,\"figure\"],[15,0,[28,[37,0],[\"o--mediaContainer cPV--mediaContainer\"],null]],[12],[1,\"\\n\"],[41,[30,0,[\"textOnlyDraft\"]],[[[1,\"    \"],[10,2],[14,0,\"cPV--mediaContainer__text\"],[12],[1,\"\\n      \"],[1,[30,1,[\"description\"]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,\"img\"],[15,\"alt\",[28,[37,2],[\"shared_words.draft\"],null]],[15,0,[28,[37,0],[\"o--media\",[52,[30,1,[\"hasBeenEdited\"]],\"is--selected\"]],null]],[15,\"data-post-id\",[30,1,[\"id\"]]],[15,\"src\",[52,[30,1,[\"secureImageUrl\"]],[30,1,[\"secureImageUrl\"]],\"/assets/images/img--postThumbnail--placeholder--preview.png\"]],[12],[13],[1,\"\\n\"]],[]]],[41,[51,[30,0,[\"hideActions\"]]],[[[1,\"    \"],[10,0],[14,0,\"cPV--media__darkOverlay\"],[12],[13],[1,\"\\n\"],[41,[30,1,[\"isDraftPost\"]],[[[1,\"      \"],[10,1],[14,0,\"o--media__label--draft\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"draft-post\"],[[\"class\"],[\"o--icon--lg o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[28,[37,5],[[30,1,[\"canMove\"]],[30,2]],null],[[[1,\"      \"],[10,1],[14,0,\"o--media__label--status\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"move\"],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"isIgPost\"]],[[[1,\"      \"],[10,1],[14,0,\"o--media__label--status\"],[12],[1,\"\\n        \"],[10,\"i\"],[14,0,\"i--ig--w\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[28,[37,5],[[30,1,[\"canDelete\"]],[30,2]],null],[[[1,\"      \"],[11,1],[24,0,\"o--media__label--select\"],[4,[38,6],[\"click\",[28,[37,7],[[30,3],[30,1]],null]],null],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"close\"],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"isCarouselPost\"]],[[[1,\"      \"],[10,1],[14,0,\"o--media__label--type\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"gallery\"],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"isReelsPost\"]],[[[1,\"      \"],[10,1],[14,0,\"o--media__label--type\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"ig-reels\"],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"shouldShowVideoIcon\"]],[[[1,\"      \"],[10,1],[14,0,\"o--media__label--type\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[[30,1,[\"mediaIcon\"]]],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"gram\",\"autoPublish\"]],[[[1,\"      \"],[10,1],[14,0,\"o--media__label--method\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"instant\"],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,1,[\"gram\",\"isNotificationPost\"]],[[[1,\"      \"],[10,1],[14,0,\"o--media__label--method\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"notification\"],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]],null]],[]]]],[]],null],[1,\"\\n  \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n\"],[13]],[\"@post\",\"@isFeedTab\",\"@removePreviewPost\"],false,[\"concat-classes\",\"if\",\"t\",\"unless\",\"svg-jar\",\"and\",\"on\",\"fn\"]]",
    "moduleName": "preview-grid/components/post.hbs",
    "isStrictMode": false
  });
  class PostComponent extends _component2.default {
    get hideActions() {
      return this.args.post.isReelsPost && this.args.needReelsUpgrade;
    }
    get textOnlyDraft() {
      return !this.args.post.secureImageUrl && Boolean(this.args.post.description);
    }
  }
  _exports.default = PostComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PostComponent);
});